"use client";
import { createContext, useContext } from "react";
const HeroContext = createContext({});
function useHeroContext() {
    return useContext(HeroContext);
}
export { HeroContext, useHeroContext };
